import { Heading_1 as Heading1, PrimaryButton } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import BackButton from '../../BackButton/BackButton';
import styles from '../bankPaymentRedemption.module.scss';

export const RetryView = ({ onRetry, isLoading }) => (
  <div className={styles.container} data-test-id="bank-payment-retry-view">
    <div className={styles.header}>
      <Heading1>{dictionary.bankPayment.labels.retryTitle}</Heading1>
    </div>
    <p className={styles.body}>{dictionary.bankPayment.copy.retryBody}</p>
    <div className={styles.ctaWrapper}>
      <PrimaryButton
        onClick={onRetry}
        label={
          isLoading
            ? dictionary.bankPayment.labels.connectingCta
            : dictionary.bankPayment.labels.tryAgainCta
        }
        disabled={isLoading}
        className={styles.cta}
        data-test-id="bank-payment-retry-cta"
      />
    </div>
    <BackButton className={styles.backButton} />
  </div>
);

RetryView.propTypes = {
  onRetry: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default RetryView;
